module.exports = __webpack_public_path__ + "static/media/Rally-ResearchProcess.a4711a49.pdf";